// const localNodeURI = 'http://127.0.0.1:9000';

const useGateway = false;
const isDev = false;

const baseURI_dev = useGateway ? 'http://172.30.50.20:9000' : 'http://172.30.50.20:60/_version_/service';
const baseURI_production = useGateway ? 'http://172.30.50.20:9000' : '/_version_/service';

export const appConfig = {
	isDevelopment: isDev,
	apiBaseUrl: isDev ? baseURI_dev : baseURI_production,
	useGateway,
};

// window?.process?.env?.NODE_ENV !== 'production'
